import { ArrowRight, Github, Linkedin, Mail, Twitter } from './icons'
import { Reveal } from '../hooks/useReveal'

const SOCIALS = [
  { key: 'github', label: 'GitHub', Icon: Github },
  { key: 'linkedin', label: 'LinkedIn', Icon: Linkedin },
  { key: 'twitter', label: 'Twitter', Icon: Twitter },
]

export const Contact = ({ profile }) => {
  const { links, name } = profile

  return (
    <>
      <section className="section" id="contact">
        <div className="container">
          <Reveal className="contact">
            <p className="eyebrow">Contact</p>
            <h2 className="contact__title">Have something to build?</h2>
            <p className="lead contact__lead">
              My current engagement wraps up at the end of September 2026, so
              I am actively looking for the next one — permanent or contract.
              Happy to talk about distributed systems, streaming, or anything
              close to the metal.
            </p>

            <a className="btn btn--primary" href={links.email}>
              Send an email
              <ArrowRight className="btn__arrow" />
            </a>

            <ul className="social">
              {SOCIALS.map(({ key, label, Icon }) => (
                <li key={key}>
                  <a
                    href={links[key]}
                    target="_blank"
                    rel="noreferrer noopener"
                    aria-label={`${name} on ${label}`}
                    title={label}
                  >
                    <Icon />
                  </a>
                </li>
              ))}
              <li>
                <a href={links.email} aria-label={`Email ${name}`} title="Email">
                  <Mail />
                </a>
              </li>
            </ul>
          </Reveal>
        </div>
      </section>

      <footer className="footer">
        <div className="container footer__inner">
          <p>&copy; {new Date().getFullYear()} {name}</p>
          <nav className="footer__links" aria-label="Footer">
            <a href="/privacy">Privacy</a>
            <a href="#top">Back to top</a>
          </nav>
        </div>
      </footer>
    </>
  )
}
